import { render, staticRenderFns } from "./OrganisationCategoryList.vue?vue&type=template&id=71b67380&scoped=true&"
import script from "./OrganisationCategoryList.vue?vue&type=script&lang=js&"
export * from "./OrganisationCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationCategoryList.vue?vue&type=style&index=0&id=71b67380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b67380",
  null
  
)

export default component.exports